<template>
    <div>
<!--        <div class="grid lg:grid-cols-3">-->
<!--            <div class="lg:col-span-2">-->
<!--                <dashboard-insights :insights="insights"></dashboard-insights>-->
<!--            </div>-->
<!--            <div class="lg:col-span-1 lg:pl-8">-->
<!--                <dashboard-email-accounts :emails="emails"></dashboard-email-accounts>-->
<!--            </div>-->
<!--        </div>-->

        <h1 class="mt-12 text-2xl font-bold text-blue-900">Quick Links</h1>
        <div class="mt-3 rounded-lg bg-gray-200 overflow-hidden border border-gray-200 divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-3 sm:gap-px">
        <a href="/storage/board-meeting-dates.pdf" target="_blank" class="rounded-tl-lg rounded-tr-lg sm:rounded-tr-none relative block group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-teal-50 text-teal-700 ring-4 ring-white">
                      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <div class="focus:outline-none" >
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Advisory Board Meeting Dates
                    </div>
                </h3>
            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>

<!--        <inertia-link :href="route('cottonseed-tickets')" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">-->
<!--            <div>-->
<!--                    <span class="rounded-lg inline-flex p-3 bg-purple-50 text-purple-700 ring-4 ring-white">-->
<!--                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path></svg>-->
<!--                    </span>-->
<!--            </div>-->
<!--            <div class="mt-4">-->
<!--                <h3 class="text-lg font-medium">-->
<!--                    <p class="focus:outline-none">-->
<!--                        <span aria-hidden="true" class="absolute inset-0"></span>-->
<!--                        Cottonseed Tickets-->
<!--                    </p>-->
<!--                </h3>-->
<!--            </div>-->
<!--            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">-->
<!--                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>-->
<!--            </span>-->
<!--        </inertia-link>-->

        <a target="_blank" :href="`${$page.props.auth.user.webbos}`" class="cursor-pointer sm:rounded-tr-lg relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                <span class="rounded-lg inline-flex p-3 bg-yellow-50 text-yellow-700 ring-4 ring-white">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Contract Fulfillment
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>

        <a target="_blank" :href="`${$page.props.auth.user.webbos}`" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-light-blue-50 text-light-blue-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <!-- Extend touch target to entire panel -->
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Daily Balance Activity
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>

        <inertia-link :href="route('financials')"  class="relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-lime-50 text-lime-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <!-- Extend touch target to entire panel -->
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Documents &amp; Financials
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <a href="http://www.pycoindustries.com/members/GinMemberPortal" target="_blank" class="relative block cursor-pointer bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-pink-50 text-pink-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <div class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Gin Board Members
                    </div>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>

        <inertia-link :href="route('wires')" class="relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-indigo-50 text-indigo-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <a class="focus:outline-none" href="#">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Online Wires
                    </a>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

<!--        <inertia-link :href="route('outturn-listings')" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">-->
<!--            <div>-->
<!--                    <span class="rounded-lg inline-flex p-3 bg-rose-50 text-rose-700 ring-4 ring-white">-->
<!--                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path></svg>-->
<!--                    </span>-->
<!--            </div>-->
<!--            <div class="mt-4">-->
<!--                <h3 class="text-lg font-medium">-->
<!--                    <a class="focus:outline-none" href="#">-->
<!--                        &lt;!&ndash; Extend touch target to entire panel &ndash;&gt;-->
<!--                        <span aria-hidden="true" class="absolute inset-0"></span>-->
<!--                        Outturn Details-->
<!--                    </a>-->
<!--                </h3>-->

<!--            </div>-->
<!--            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">-->
<!--                    <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>-->
<!--                </span>-->
<!--        </inertia-link>-->

        <inertia-link :href="route('monthly-statement')"  class="cursor-pointer rounded-bl-lg rounded-br-lg sm:rounded-bl-none relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-cyan-50 text-cyan-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <div class="focus:outline-none">
                        <!-- Extend touch target to entire panel -->
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Monthly Statements (PRIOR to MAY 2022)
                    </div>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                    <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
                </span>
        </inertia-link>
        <a target="_blank" :href="`${$page.props.auth.user.webbos}`"   class="cursor-pointer rounded-bl-lg rounded-br-lg sm:rounded-bl-none relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                <span class="rounded-lg inline-flex p-3 bg-cyan-50 text-cyan-700 ring-4 ring-white">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"></path></svg>
                </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <div class="focus:outline-none">
                        <!-- Extend touch target to entire panel -->
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Monthly Statements (MAY 2022 - Current)
                    </div>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>
    </div>
    </div>
</template>

<script>
import DashboardInsights from '@/Components/Dashboard/DashboardInsights'
import DashboardEmailAccounts from '@/Components/Dashboard/DashboardEmailAccounts'

export default {
    components: {DashboardInsights, DashboardEmailAccounts},
    props: {
        insights: {
            type: Object,
            default: {}
        },
        emails: {
            type: Array,
        }
    },
}
</script>
